import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const cameraUpdateAtom = createMutationAtomFactory(
  'settings.cameraUpdate',
  (params: {
    id: string;
    name?: string;
    streamProfile?: string;
    streamUrl?: string;
    snapshotUrl?: string;
  }) => ({
    iotCameraUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          streamProfile: params.streamProfile,
          streamUrl: params.streamUrl,
          snapshotUrl: params.snapshotUrl,
        },
      },
      id: true,
      name: true,
      streamProfile: true,
      streamUrl: true,
      snapshotUrl: true,
      status: true,
    },
  }),
);
